import React, { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import {
    Card,
    CardBody,
    Col,
    Container,
    Form,
    FormFeedback,
    Input,
    Label,
    Row,
} from "reactstrap";

import Select from "react-select";
import Breadcrumbs from "components/Common/Breadcrumb";

import { useFormik } from "formik";
import * as Yup from "yup";

import CommonDialog from "components/Common/CommonDialog";
import ToastDialog from "components/Common/ToastDialog";

import { useToast } from "ToastStore";
import { getCityList, getStateList } from "helpers/UAM/state.helper";
import { addSalesOffice, editSalesOffice, getSalesOffice } from "helpers/UAM/salesoffice.helper";
import { isEmpty } from "lodash";
import { getRegionList } from "http/Region";
import { SystemConfigurationContext } from "context/systemConfigContext";

const AddOrEditSalesOffice = () => {
    const [stateList, setStateList] = useState([]);
    const [cityList, setCityList] = useState([]);
    const [regionOptions, setRegionOptions] = useState([]);
    const [showCommonDialog, setShowCommonDialog] = useState({ isShow: false });
    const [toastInfo, setToastInfo] = useState({ showToast: false });
    const navigate = useNavigate();
    const {inputMax} = useContext(SystemConfigurationContext)

    const [salesOffice, setSalesOffice] = useState({})
    const urlParams = new URLSearchParams(window.location.search)
    const encodedId = urlParams.get("id")
    const decodedId = atob(encodedId)
    const {roleName} = JSON.parse(localStorage.getItem("user"))

    const { handleToastData } = useToast();

    document.title = encodedId ? "Edit Sales Office | DMS" : "Add Sales Office | DMS"


    const getOptionsList = async () => {
        const apiRes = await getRegionList()
        if (apiRes.status) {
            const  regions = apiRes?.data?.data;
            if (!isEmpty(regions)) {
                setRegionOptions(regions.map(item => {
                    return { label: item['regionName'], value: item['regionName'] }
                }));
            }
        }
        else {
            setToastInfo({
                message: apiRes.message,
                showToast: true,
                role: "error",
            })
        }
    }


    useEffect(() => {
        getOptionsList()
        getStateList()
            .then((response) => {
                if (response.code == "200") {
                    setStateList(response.data);
                }
            })
            .catch((error) => { });
        if (encodedId) {
            getSalesOffice({ salesOfficeId: decodedId })
                .then(responseFromAPI => {
                    if (responseFromAPI.status && responseFromAPI.code == 200) {
                        setSalesOffice(responseFromAPI.data)
                        getCityListHelper(responseFromAPI.data.address.state)
                    }
                })
                .catch(error => { })

        }
    }, [])
    const validation = useFormik({
        enableReinitialize: true,

        initialValues: {
            region: salesOffice.region || "",
            salesOfficeCode: salesOffice.salesOfficeCode || "",
            salesOfficeName: salesOffice.salesOfficeName || "",
            email: salesOffice.email || "",
            mobileNo: salesOffice.mobileNo || "",

            address: salesOffice.address?.address1 || "",
            city: salesOffice.address?.city || "",
            state: salesOffice.address?.state || "",
            pincode: salesOffice.address?.pincode || "",

        },

        validationSchema: Yup.object({
            region: Yup.string().required('Region is required'),
            salesOfficeCode: Yup.string().required('Sales Office Code is required'),
            salesOfficeName: Yup.string().required('Sales Office Name is required'),
            mobileNo: Yup.string()
                .typeError("Mobile Number must be a number")
                .required('Sales Office Mobile number is required')
                .matches(/^\d{10}$/, "Mobile Number must be 10 digits number"),
            email: Yup.string()
                .email('Invalid email address')
                .required('Sales Office Email ID is required'),

            address: Yup.string().required('Address is required'),
            city: Yup.string().required('City is required'),
            state: Yup.string().required('State is required'),
            pincode: Yup.number()
                .required('Pincode is required')
                .typeError("Pincode must be a number")
                .positive("Pincode must be a positive number")
                .integer("Pincode must be an integer")
                .test('len', 'Pincode must be exactly 6 digits', val => val && val.toString().length === 6),
        }),

        onSubmit: (values) => {
            const message = encodedId ? 'Are you sure want to edit sales office?' : 'Do you want to save entry?'
            setShowCommonDialog({ isShow: true, message })
        }
    });

    const handleCancel = () => {
        navigate(-1)
    }
    
    const submitSalesOffice = () => {
        const { values } = validation
        const salesOfficeData = {
            region: values.region,
            salesOfficeCode: values.salesOfficeCode,
            salesOfficeName: values.salesOfficeName,
            address: values.address,
            state: values.state,
            city: values.city,
            pincode: values.pincode,
            email: values.email,
            mobileNo: values.mobileNo
        }
        if (encodedId) {
            salesOfficeData['id'] = decodedId;
            salesOfficeData['addressId'] = salesOffice.addressId
            editSalesOffice(salesOfficeData)
                .then(responseFromAPI => {
                    if (responseFromAPI.status) {
                        handleToastData(` ${responseFromAPI.message}`, "warning")
                        validation.resetForm()
                        navigate(`/${roleName}/sales-office`);

                    } else {
                        setToastInfo({
                            message: responseFromAPI.message,
                            showToast: true,
                            role: "error",
                        });
                    }
                })
                .catch(error => { })
        } else {
            addSalesOffice(salesOfficeData)
                .then(responseFromAPI => {
                    if (responseFromAPI.status) {
                        handleToastData(`${salesOfficeData.region} ${responseFromAPI.message}`, "success")
                        validation.resetForm()
                        navigate(`/${roleName}/sales-office`);
                    } else {
                        setToastInfo({
                            message: responseFromAPI.message,
                            showToast: true,
                            role: "error",
                        });
                    }
                })
                .catch(error => { })
        }

    }

    const dialogAction = (action, data) => {
        if (action == 1) {
            setShowCommonDialog({ isShow: false })
            submitSalesOffice()
        } else {
            setShowCommonDialog({ isShow: false })
        }
    }

    function setStateValue(data, state) {
        if (state) {
            for (const item of data) {
                if (item.name === state) {
                    const value = { label: `${item.name}`, value: state };
                    return value;
                }
            }
        }
    }

    function setCityValue(data, city) {
        if (city) {
            for (const item of data) {
                if (item.cityName === city) {
                    const value = { label: `${item.cityName}`, value: city };
                    return value;
                }
            }
        } else {
            return null
        }
    }


    const handleInputChange = (value) => {
        validation.setFieldValue("state", value);
        validation.setFieldValue("city", "")
        getCityListHelper(value)
    };

    const handleCityChange = (value) => {
        validation.setFieldValue("city", value);
    };

    const getCityListHelper = (value) => {
        getCityList({ state: value })
            .then((response) => {
                if (response.status) {
                    setCityList(response.data)
                }
            })
            .catch((error) => { })
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <div className="ms-2">
                <Breadcrumbs title="Sales Office" breadcrumbItem={encodedId ? "Edit Sales Office" : "Add Sales Office"} />
                </div>
                <Container fluid>
                    <Card>
                        <CardBody>
                            <Form
                                onSubmit={(e) => {
                                    e.preventDefault();
                                    validation.handleSubmit();
                                    return false;
                                }}
                            >
                                <h5 className="mt-2" style={{ color: "#7B8788" }}>Sales Office Details</h5>
                                <Row>
                                    <Col sm="12" md="6">
                                        <Label className="form-label mt-2 required">Region Name</Label>
                                        <Select
                                            options={regionOptions}
                                            className={`select-dropdown ${validation.touched.region && validation.errors.region
                                                ? "is-invalid"
                                                : ""
                                                }`}
                                            name="region"
                                            id="region"
                                            onChange={(selectedOption) => {
                                                validation.setFieldValue("region", selectedOption.value);
                                            }}
                                            value={regionOptions.filter(
                                                (option) => option.value === validation.values.region
                                            )}
                                        />
                                        {validation.touched.region && validation.errors.region ? (
                                            <FormFeedback type="invalid">{validation.errors.region}</FormFeedback>
                                        ) : null}
                                    </Col>

                                    <Col sm="12" md="6">
                                        <Label className="form-label mt-2 required">
                                            Sales Office Code
                                        </Label>
                                        <Input
                                            maxLength={inputMax}
                                            name="salesOfficeCode"
                                            type="text"
                                            placeholder="Enter Sales Office Code"
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.salesOfficeCode || ""}
                                            invalid={
                                                validation.touched.salesOfficeCode &&
                                                validation.errors.salesOfficeCode
                                            }
                                        />
                                        {validation.touched.salesOfficeCode &&
                                            validation.errors.salesOfficeCode ? (
                                            <FormFeedback type="invalid">
                                                {validation.errors.salesOfficeCode}
                                            </FormFeedback>
                                        ) : null}
                                    </Col>

                                    <Col sm="12" md="6">
                                        <Label className="form-label mt-2 required">
                                            Sales Office Name
                                        </Label>
                                        <Input
                                           maxLength={inputMax}
                                            name="salesOfficeName"
                                            type="text"
                                            placeholder="Enter Sales Office Name"
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.salesOfficeName || ""}
                                            invalid={
                                                validation.touched.salesOfficeName &&
                                                validation.errors.salesOfficeName
                                            }
                                        />
                                        {validation.touched.salesOfficeName &&
                                            validation.errors.salesOfficeName ? (
                                            <FormFeedback type="invalid">
                                                {validation.errors.salesOfficeName}
                                            </FormFeedback>
                                        ) : null}
                                    </Col>

                                    <Col sm="12" md="6">
                                        <Label className="form-label mt-2 required">
                                            Email Id
                                        </Label>
                                        <Input
                                           maxLength={inputMax}
                                            name="email"
                                            type="email"
                                            placeholder="Enter Your Email"
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.email || ""}
                                            invalid={
                                                validation.touched.email &&
                                                validation.errors.email
                                            }
                                        />
                                        {validation.touched.email &&
                                            validation.errors.email ? (
                                            <FormFeedback type="invalid">
                                                {validation.errors.email}
                                            </FormFeedback>
                                        ) : null}
                                    </Col>

                                    <Col sm="12" md="6">
                                        <Label className="form-label mt-2 required">
                                            Mobile
                                        </Label>
                                        <Input
                                           maxLength={inputMax}
                                            name="mobileNo"
                                            type="text"
                                            placeholder="Enter Mobile Number"
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.mobileNo || ""}
                                            invalid={
                                                validation.touched.mobileNo &&
                                                validation.errors.mobileNo
                                            }
                                        />
                                        {validation.touched.mobileNo &&
                                            validation.errors.mobileNo ? (
                                            <FormFeedback type="invalid">
                                                {validation.errors.mobileNo}
                                            </FormFeedback>
                                        ) : null}
                                    </Col>
                                </Row>

                                <h5 className="mt-5" style={{ color: "#7B8788" }}>Address Details</h5>
                                <Row>
                                    <Col sm="12" md="6">
                                        <Label className="form-label mt-2 required">
                                            Address
                                        </Label>
                                        <Input
                                           maxLength={inputMax}
                                            name="address"
                                            type="text"
                                            placeholder="Enter your Address"
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.address || ""}
                                            invalid={
                                                validation.touched.address &&
                                                validation.errors.address
                                            }
                                        />
                                        {validation.touched.address &&
                                            validation.errors.address ? (
                                            <FormFeedback type="invalid">
                                                {validation.errors.address}
                                            </FormFeedback>
                                        ) : null}
                                    </Col>

                                    <Col sm="12" md="6">
                                        <Label className="form-label mt-2 required">State</Label>
                                        <Select
                                            options={stateList.map((option) => ({
                                                label: option.name,
                                                value: option.name,
                                            }))}
                                            className={`select-dropdown ${validation.touched.state && validation.errors.state
                                                ? "is-invalid"
                                                : ""
                                                }`}
                                            name="state"
                                            id="state"
                                            onChange={(selectedOption) => {
                                                handleInputChange(selectedOption.value);
                                            }}
                                            value={setStateValue(
                                                stateList,
                                                validation.values.state
                                            )}
                                        />
                                        {validation.touched.state && validation.errors.state ? (
                                            <FormFeedback type="invalid">
                                                {validation.errors.state}
                                            </FormFeedback>
                                        ) : null}
                                    </Col>

                                    <Col sm="12" md="6">
                                        <Label className="form-label mt-3 required">City</Label>
                                        <Select
                                            options={cityList.map((option) => ({
                                                label: option.cityName,
                                                value: option.cityName,
                                            }))}
                                            className={`select-dropdown ${validation.touched.city && validation.errors.city
                                                ? "is-invalid"
                                                : ""
                                                }`}
                                            name="city"
                                            id="city"
                                            onChange={(selectedOption) => {
                                                handleCityChange(selectedOption.value);
                                            }}
                                            value={setCityValue(
                                                cityList,
                                                validation.values.city
                                            )}
                                        />
                                        {validation.touched.city && validation.errors.city ? (
                                            <FormFeedback type="invalid">
                                                {validation.errors.city}
                                            </FormFeedback>
                                        ) : null}
                                    </Col>

                                    <Col sm="12" md="6">
                                        <Label className="form-label mt-3 required">Pincode</Label>
                                        <Input
                                           maxLength={inputMax}
                                            name="pincode"
                                            type="number"
                                            placeholder="Enter Pincode"
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.pincode || ""}
                                            invalid={
                                                validation.touched.pincode &&
                                                validation.errors.pincode
                                            }
                                        />
                                        {validation.touched.pincode &&
                                            validation.errors.pincode ? (
                                            <FormFeedback type="invalid">
                                                {validation.errors.pincode}
                                            </FormFeedback>
                                        ) : null}
                                    </Col>
                                </Row>

                                <Row>
                                    <Col className="mt-4">
                                        <div className="d-flex gap-3 justify-content-end">
                                            <button
                                                className="btn btn-outline-secondary"
                                                type="button"
                                                onClick={handleCancel}
                                            >
                                                Cancel
                                            </button>
                                            <button
                                                type="submit"
                                                className="btn btn-success save-customer"
                                            >
                                                Save
                                            </button>
                                        </div>
                                    </Col>
                                </Row>
                            </Form>
                        </CardBody>
                    </Card>
                </Container>
            </div>
            {
                showCommonDialog &&
                <CommonDialog
                    isShow={showCommonDialog.isShow}
                    message={showCommonDialog.message} data={showCommonDialog.data}
                    postitiveBtn={'Submit'} negativeBtn={'Close'} onCloseFn={dialogAction}
                />
            }
            <ToastDialog
                message={toastInfo.message}
                showToast={toastInfo.showToast}
                role={toastInfo.role}
                onCloseFn={() => setToastInfo({ showToast: false })}
            />
        </React.Fragment>

    )
}

export default AddOrEditSalesOffice